import React, { useRef } from 'react';
import useRevealOnMount from '../hooks/useRevealOnMount';
import SusuGame from './SusuGame';
import './Art.css';

const ART_ITEMS = [
  { id: 'matrix-rain', src: '/images/playground-matrix-rain.mp4', alt: 'Matrix digital rain over nature bokeh', title: 'Matrix Rain', category: 'Vibe-coded', video: true },
  { id: 'find-susu', title: 'Find Susu', category: 'p5.js', game: true },
  { id: 'polar-panda', src: '/images/playground-polar-panda.png', alt: 'Polar bear and panda painting', title: 'Polar Bear & Panda', category: 'Painting' },
  { id: 'peeking-cat', src: '/images/art-peeking-cat.jpg', alt: 'Tabby cat peeking in from the edge of the paper', title: 'Peekaboo', category: 'Painting' },
  { id: 'rhino', src: '/images/playground-rhino-painting.png', alt: 'Rhino painting', title: 'Rhino', category: 'Painting' },
  { id: 'bear', src: '/images/playground-bear-painting.png', alt: 'Bear closeup drawing', title: 'Bear', category: 'Painting' },
  { id: 'xiaodi', src: '/images/playground-xiaodi-birthday.png', alt: 'Xiaodi birthday painting', title: "Xiaodi's Birthday", category: 'Painting' },
  { id: 'cat-portrait', src: '/images/art-maine-coon.jpg', alt: 'Maine Coon cat portrait', title: 'Maine Coon', category: 'Painting' },
  { id: 'cherry-blossom-ride', src: '/images/art-cherry-blossom-figma.png', alt: 'Shiba in bike basket with cherry blossoms', title: 'Cherry Blossom Ride', category: 'Painting' },
];

export default function Art() {
  const innerRef = useRef(null);
  useRevealOnMount(innerRef);

  const renderItem = (item) => (
    <figure key={item.id} className="art-item reveal-item">
      <div className="art-thumb">
        {item.game ? (
          <SusuGame />
        ) : item.video ? (
          <video src={item.src} autoPlay loop muted playsInline preload="auto" />
        ) : (
          <img src={item.src} alt={item.alt} loading="lazy" />
        )}
      </div>
      <figcaption className="art-meta">
        <span className="art-title">{item.title}</span>
        <span className="art-category">{item.category}</span>
      </figcaption>
    </figure>
  );

  return (
    <div className="art-page">
      <section className="art-cols" ref={innerRef} aria-label="Art">
        <div className="art-col">
          {ART_ITEMS.filter((_, i) => i % 2 === 0).map(renderItem)}
        </div>
        <div className="art-col">
          {ART_ITEMS.filter((_, i) => i % 2 === 1).map(renderItem)}
        </div>
      </section>
    </div>
  );
}
